var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-action-log',{attrs:{"actionLog":_vm.actionLog,"actionNameLabel":_vm.actionNameLabel,"iconClass":['font-size__small', 'fal fa-check-circle', 'color__blue']}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9784cda4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminstration/ketluan/hc-commands-ycbs-action-log.vue
// module id = null
// module chunks = 